import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputTvaNumberError = (
  <Trans>
    Ce champ doit posséder un numéro de TVA valide
  </Trans>
);
